import React from 'react';

const InfoTiles = () => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
      <div className="bg-gray-800 rounded-xl p-6 shadow-lg hover:shadow-purple-500/10 transition-all">
        <div className="flex items-center mb-4 text-purple-400">
          <svg className="w-8 h-8 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <h3 className="text-xl font-semibold text-white">Ügyfélszolgálat</h3>
        </div>
        <div className="space-y-3 text-gray-300">
          <p className="flex items-center">
            <span className="font-medium mr-2">Hétköznap:</span> 8:00 - 17:00
          </p>
          <p className="flex items-center">
            <span className="font-medium mr-2">Hétvégén:</span> 9:00 - 14:00
          </p>
          <p className="text-sm text-purple-400 mt-4">
            Sürgős esetben 0-24 órás ügyelet!
          </p>
        </div>
      </div>

      <div className="bg-gray-800 rounded-xl p-6 shadow-lg hover:shadow-purple-500/10 transition-all">
        <div className="flex items-center mb-4 text-purple-400">
          <svg className="w-8 h-8 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
          </svg>
          <h3 className="text-xl font-semibold text-white">Kiszállás</h3>
        </div>
        <div className="space-y-3 text-gray-300">
          <p>Budapest területén 24 órán belül</p>
          <p>Pest megyében 48 órán belül</p>
          <p className="text-sm text-purple-400 mt-4">
            Sürgős esetben soron kívüli kiszállás!
          </p>
        </div>
      </div>

      <div className="bg-gray-800 rounded-xl p-6 shadow-lg hover:shadow-purple-500/10 transition-all">
        <div className="flex items-center mb-4 text-purple-400">
          <svg className="w-8 h-8 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
          </svg>
          <h3 className="text-xl font-semibold text-white">Garancia</h3>
        </div>
        <div className="space-y-3 text-gray-300">
          <p>Minden munkánkra 100% garanciát vállalunk</p>
          <p>Szerződéses partnereknek kiemelt támogatás</p>
          <p className="text-sm text-purple-400 mt-4">
            Ingyenes állapotfelmérés és árajánlat!
          </p>
        </div>
      </div>
    </div>
  );
};

export default InfoTiles; 